<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light" @keyup.enter="load">
                <b-row class="my-3 align-items-center">
                    <b-col cols='10'>
                        <b-row class="align-items-center">
                            <b-col>
                                <lg-form-input v-model="pesquisa" label=" "></lg-form-input>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols='2' class='d-flex justify-content-center align-items-center'>
                        <b-button id="localizar" class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                            @click="load">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                                <b-tooltip target="localizar" title="Localizar" triggers="hover"></b-tooltip>
                            </div>
                        </b-button>
                        <b-button id="Limpar" class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                            @click="clearForm">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="Limpar" title="Limpar" triggers="hover"></b-tooltip>
                        </b-button>
                        <b-button id="novo" v-b-tooltip.hover.top="'Novo'" class="mr-2 my-2" size="sm"
                            style="height: 20px" pill @click="showModalNovoProcesso" variant="primary">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" />
                            </div>
                        </b-button>
                    </b-col>
                </b-row>
            </b-card>
            <b-card bg-variant="light" class="mt-3">
                <b-table responsive class="mt-2" show-empty small :busy="busy" :items="records" :fields="fields" hover>
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template v-slot:cell(dataCriacao)="data">
                        <span v-if="data.item.dataCriacao">
                            {{ formatDate(data.item.dataCriacao) }}
                        </span>
                        <span v-else>
                            N/A
                        </span>
                    </template>
                    <template v-slot:cell(status)="data">
                        <b-badge :variant="badgeVariant(data.item.idStatus)" class="badge">
                            {{ formatSituacao(data.item.idStatus) }}
                        </b-badge>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <b-row class='justify-content-end pr-4'>
                            <b-button
                                v-if="TipoRequisicaoCompraEnum.LICITACAO.cod == data.item.tipoCompra && data.item.idStatus === StatusEnum.PROCESSO_COMPRA_EM_ANDAMENTO.value"
                                v-b-tooltip.hover.top="'Contrato'" class="my-2 mx-1" size="sm" pill variant="primary"
                                @click="showModalContrato(data.item)">
                                <b-icon icon="file-earmark-richtext" />
                            </b-button>

                            <b-button
                                v-if="TipoRequisicaoCompraEnum.REGISTRO_PRECO.cod == data.item.tipoCompra && data.item.idStatus === StatusEnum.PROCESSO_COMPRA_EM_ANDAMENTO.value"
                                v-b-tooltip.hover.top="'Ata de Registro de Preço'" class="my-2 mx-1" size="sm" pill
                                variant="primary" @click="showModalAta(data.item)">
                                <b-icon icon="file-earmark-richtext" />
                            </b-button>

                            <b-button v-b-tooltip.hover.top="'Autorização de Fornecimento'"
                                v-if="(TipoRequisicaoCompraEnum.COMPRA_DIRETA.cod == data.item.tipoCompra || TipoRequisicaoCompraEnum.ADESAO_ATA_REGISTRO_PRECO.cod == data.item.tipoCompra)"
                                class="my-2 mx-1" size="sm" pill variant="primary"
                                @click="showModalAutorizacaoFornecedor(data.item)">
                                <b-icon icon="check-circle" />
                            </b-button>
                            <b-button
                                v-if="data.item.idStatus === StatusEnum.PROCESSO_COMPRA_AGUARDANDO_APROVACAO.value"
                                v-b-tooltip.hover.top="'Aprovar'" class="my-2 mx-1" size="sm" pill variant="success"
                                @click="aprovarProcesso(data.item)">
                                <b-icon icon="check-circle" />
                            </b-button>
                            <b-button
                                v-if="data.item.idStatus === StatusEnum.PROCESSO_COMPRA_AGUARDANDO_APROVACAO.value"
                                v-b-tooltip.hover.top="'Rejeitar'" class="my-2 mx-1" size="sm" pill variant="danger"
                                @click="rejeitarProcesso(data.item)">
                                <b-icon icon="x-circle" />
                            </b-button>
                            <b-button v-if="data.item.idStatus === StatusEnum.PROCESSO_COMPRA_EM_ANDAMENTO.value"
                                v-b-tooltip.hover.top="'Editar'" class="my-2 mx-1" size="sm" pill variant="primary"
                                @click="editar(data.item)">
                                <b-icon icon="pencil-square" />
                            </b-button>
                            <b-button v-b-tooltip.hover.top="'Visualizar'" class="my-2 mx-1" size="sm" pill
                                variant="primary" @click="visualizar(data.item)">
                                <b-icon icon="eye" />
                            </b-button>
                        </b-row>
                    </template>
                </b-table>
                <b-row style="margin-top: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
            <ConsultarProcessoCompraForm v-if="mostrarModalNovoProcesso" :title="[title.join(' > ')]"
                :idProcesso="selectedProcessoId || null" :isViewMode="isViewMode || false" @submit="load"
                @close='fecharModalNovoProcesso' />

            <LgFinderPageConsultarAutorizacaoFornecimento :statusId="statusId" :isModal="true"
                v-if="mostrarModalAutorizacaoFornecedor" :prefix="title.join(' > ') + ' > '"
                :processoId="selectedProcessoId" @input='fecharModalAutorizacaoFornecedor' />


            <LgFinderPageContrato :processoCompra="processoSelected" @input="handleContrato" :isModal="true"
                v-if="mostrarModalContrato" :label="'Contrato:*'" v-model="contrato" :prefix="title.join(' > ') + ' > '"
                id="ContratoProcessoCompra" />
            <LgFinderPageAta :processoCompra="processoSelected" @input="handleAta" :isModal="true"
                v-if="mostrarModalAta" v-model="ata" :prefix="title.join(' > ') + ' > '" id="ContratoProcessoCompra" />

        </b-card-body>
    </b-card>
</template>

<script>
import ConsultarProcessoCompraForm from "./ConsultarProcessoCompraForm.vue"
import ProcessoCompraService from "@/core/api/ProcessoCompraService"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import StatusEnum from "@/core/utils/StatusEnum"
import Swal from "sweetalert2"
import { ListResourceMixin } from "@/core/mixins/resource";
import ResourceService from "@/core/api/ResourceService";
import TipoRequisicaoCompraEnum from "@/core/utils/TipoRequisicaoCompraEnum"
import LgFinderPageContrato from "@/components/Finders/LgFinderPageContrato.vue"
import LgFinderPageConsultarAutorizacaoFornecimento from "@/components/Finders/LgFinderPageConsultarAutorizacaoFornecimento.vue"
import LgFinderPageAta from "@/components/Finders/LgFinderPageAta.vue"

export default {
    components: {
        LgFinderPageAta,
        LgFinderPageContrato,
        LgFormInput,
        ConsultarProcessoCompraForm,
        LgFinderPageConsultarAutorizacaoFornecimento,
    },
    name: "ConsultarProcessoCompra",
    data() {
        return {
            ata:{},
            mostrarModalAta: false,
            processoSelected: null,
            statusId: null,
            contrato: {},
            mostrarModalContrato: false,
            TipoRequisicaoCompraEnum: TipoRequisicaoCompraEnum,
            mostrarModalAutorizacaoFornecedor: false,
            mostrarModalNovoProcesso: false,
            pesquisa: "",
            title: ["Consultar Processos de Compra"],
            selectedProcessoId: null,
            StatusEnum,
            fields: [
                { key: "numeroProcesso", label: "Nº" },
                { key: "dataCriacao", label: "Data Criação" },
                { key: "objeto", label: "Objeto" },
                { key: "classificacaoTipoCompra", label: "Tipo de Contratação" },
                { key: "departamento", label: "Departamento" },
                { key: "valorTotal", label: "Valor Total" },

                { key: "status", label: "Status" },
                { key: "actions", label: "" },
            ],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 1,
            busy: false,
            perPageOptions: [5, 10, 25, 50],
            isViewMode: false,
        }
    },
    mixins: [ListResourceMixin],

    watch: {
        page() {
            this.load()
        },
    },
    beforeMount() {
        this.$service = new ResourceService("/api/processocompra");
        this.load()
    },
    methods: {

        handleAta() {
            this.processoSelected = null;
            this.selectedProcessoId = null;
            this.mostrarModalAta = false

        },

        handleContrato() {

            this.processoSelected = null;
            this.selectedProcessoId = null;
            this.mostrarModalContrato = false

        },

        showModalAta(processoCompra) {
            this.processoSelected = processoCompra;
            this.selectedProcessoId = processoCompra.id
            this.mostrarModalAta = true;
        },

        showModalContrato(processoCompra) {
            this.processoSelected = processoCompra;
            this.selectedProcessoId = processoCompra.id
            this.mostrarModalContrato = true;
        },
        async load() {
            this.busy = true
            this.filtro = {};
            if (this.pesquisa)
                this.filtro.pesquisa = this.pesquisa;


            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,

            });
        },
        showModalNovoProcesso() {
            this.selectedProcessoId = null
            this.isViewMode = false
            this.mostrarModalNovoProcesso = true;
        },
        fecharModalNovoProcesso() {
            this.mostrarModalNovoProcesso = false;
            this.selectedProcessoId = null
            this.isViewMode = false
            this.load()
        },
        async editar(processo) {
            this.selectedProcessoId = processo.id
            this.mostrarModalNovoProcesso = true;
        },
        async visualizar(processo) {
            this.selectedProcessoId = processo.id
            this.isViewMode = true
            this.mostrarModalNovoProcesso = true;
        },
        showModalAutorizacaoFornecedor(processo) {
            this.selectedProcessoId = processo.id;
            this.statusId = processo.idStatus;
            this.mostrarModalAutorizacaoFornecedor = true;
        },
        fecharModalAutorizacaoFornecedor() {
            this.statusId = null;
            this.mostrarModalAutorizacaoFornecedor = false;
            this.selectedProcessoId = null
            this.load()
        },
        async aprovarProcesso(processo) {
            const result = await Swal.fire({
                title: 'Você tem certeza?',
                text: "Deseja aprovar este processo de compra?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim'
            })

            if (result.isConfirmed) {
                try {
                    await ProcessoCompraService.updateStatus(processo.id, StatusEnum.PROCESSO_COMPRA_APROVADO.value)
                    this.load()
                    Swal.fire('Aprovado!', 'O processo de compra foi aprovado.', 'success')
                } catch (error) {
                    console.error("Erro ao aprovar processo:", error)
                    Swal.fire('Erro!', 'Ocorreu um erro ao aprovar o processo de compra.', 'error')
                }
            }
        },
        async rejeitarProcesso(processo) {
            const result = await Swal.fire({
                title: 'Você tem certeza?',
                text: "Deseja rejeitar este processo de compra?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim'
            })

            if (result.isConfirmed) {
                try {
                    await ProcessoCompraService.updateStatus(processo.id, StatusEnum.PROCESSO_COMPRA_REJEITADO.value)
                    this.load()
                    Swal.fire('Rejeitado!', 'O processo de compra foi rejeitado.', 'success')
                } catch (error) {
                    console.error("Erro ao rejeitar processo:", error)
                    Swal.fire('Erro!', 'Ocorreu um erro ao rejeitar o processo de compra.', 'error')
                }
            }
        },
        formatDate(dateString) {
            if (!dateString) return "N/A"
            const [datePart] = dateString.split("T")
            const [year, month, day] = datePart.split("-")
            return `${day}/${month}/${year}`
        },
        formatSituacao(situacao) {
            const status = StatusEnum.fromValue(situacao)
            return status ? status.descricao : "N/A"
        },
        badgeVariant(situacao) {
            const variants = {
                [StatusEnum.PROCESSO_COMPRA_EM_ANDAMENTO.value]: "primary",
                [StatusEnum.PROCESSO_COMPRA_AGUARDANDO_APROVACAO.value]: "secondary",
                [StatusEnum.PROCESSO_COMPRA_APROVADO.value]: "success",
                [StatusEnum.PROCESSO_COMPRA_FINALIZADO.value]: "info",
                [StatusEnum.PROCESSO_COMPRA_REJEITADO.value]: "danger",
            }
            return variants[situacao] || "secondary"
        },
        clearForm() {
            this.pesquisa = ''
            this.load()
        },
    },
}
</script>

<style scoped>
.badge {
    font-size: 85% !important;
    padding: 5px 10px !important;
}

.btn-size-alinhamento {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
